import { defineStore } from 'pinia'
import moment from "moment";
import { initialOrderData } from '../plugins/order';

export const useOrderStore = defineStore('order', {
    state: () => ({
        refresh_datetime:null,
        order_count:0,
        order_max_number_days:0,
        order_hold_count:0,
        order_pack_count:0,
        order_pack_submit_count:0,
        order_wait_count:0,
        order_defect_count:0,
        order_today_count:0,
        order_today_pack_count:0,
        edit_order_data:[],
        edit_order_pack_data:[],
        edit_wait_data:[],
        edit_pack_wait_data:[],
        edit_pack_submit_wait_data:[],
    }),
    actions: {
        get_editing_ids(type = null) {
            let result = [];
            if (type == null || type == 'is_auto') {
                for (let i=0;i<this.edit_order_data.length;i++) {
                    result.push(this.edit_order_data[i].pharmacy_medicine_id);
                }
                for (let i=0;i<this.edit_order_pack_data.length;i++) {
                    if (result.indexOf(this.edit_order_pack_data[i].pharmacy_medicine_id) == -1) {
                        result.push(this.edit_order_pack_data[i].pharmacy_medicine_id);
                    }
                }
            }
            if (type == null || type == 'is_wait') {
                for (let i=0;i<this.edit_wait_data.length;i++) {
                    result.push(this.edit_wait_data[i]);
                }
            }
            if (type == null || type == 'is_pack_submit_wait') {
                for (let i=0;i<this.edit_pack_submit_wait_data.length;i++) {
                    result.push(this.edit_pack_submit_wait_data[i].id);
                }
            }
            return result;
        },
        create_order_params(delivery_date,is_batch=false) {
            let params = {
                'pack_list':[],
                'is_auto':1,
                'orders':[],
                'delivery_date':(delivery_date ? delivery_date : ''),
                'is_batch':(is_batch ? 1 : null),
                'page_size':1000,
                'refresh_datetime':moment(this.refresh_datetime).format('YYYY-MM-DD HH:mm:ss'),
            };
            for (let i=0;i<this.edit_order_data.length;i++) {
                //余分なfieldを追加しないようにする
                params['orders'].push(initialOrderData(this.edit_order_data[i]));
            }
            //POSTデータが大きくなってしまうので小分けデータを部分的に送る
            for (let i=0;i<this.edit_order_pack_data.length;i++) {
                let record = {
                    pharmacy_medicine_id:this.edit_order_pack_data[i].pharmacy_medicine_id,
                    to_pharmacy_id:this.edit_order_pack_data[i].pharmacy.id,
                    tax_total_type:this.edit_order_pack_data[i].tax_total_type,
                    amount_float_type:this.edit_order_pack_data[i].amount_float_type,
                    assignment_date:this.edit_order_pack_data[i].assignment_date,
                    lot_no:this.edit_order_pack_data[i].lot_no,
                    expire_date:this.edit_order_pack_data[i].expire_date,
                    to_pharmacy_note:this.edit_order_pack_data[i].to_pharmacy_note,
                    number:this.edit_order_pack_data[i].number,
                    medicine_id:this.edit_order_pack_data[i].medicine.id,
                    unit_price:(this.edit_order_pack_data[i].unit_price != '' ? parseFloat(this.edit_order_pack_data[i].unit_price) : 0),
                    medicine_group_id:(this.edit_order_pack_data[i].medicine_group_id == null ? '' : this.edit_order_pack_data[i].medicine_group_id),
                }
                params['pack_list'].push(record);
            }
            return params;
        },
        search_data_index(type,id,key='pharmacy_medicine_id',conditions=null) {
            let result = -1;
            if (type == 'is_auto') {
                for (let i=0;i<this.edit_order_data.length;i++) {
                    if (this.edit_order_data[i][key] == id) {
                        if (conditions != null) { // TODO 取りあえず今は決め打ち
                            if (this.edit_order_data[i].wholesaler_id == conditions['wholesaler_id']) {
                                result = i;
                                break;
                            }
                        } else {
                            result = i;
                            break;
                        }
                    }
                }
            } else if (type == 'is_auto_pack') {
                for (let i=0;i<this.edit_order_pack_data.length;i++) {
                    if (this.edit_order_pack_data[i][key] == id) {
                        if (conditions != null) { // TODO 取りあえず今は決め打ち
                            if (this.edit_order_pack_data[i].pharmacy.id == conditions['pharmacy_id'] && this.edit_order_pack_data[i].medicine_group_id == conditions['medicine_group_id']) {
                                result = i;
                                break;
                            }
                        } else {
                            result = i;
                            break;
                        }
                    }
                }
            }
            return result;
        },
        search_data(type,id,key='pharmacy_medicine_id',conditions=null) {
            let result = null;
            let index = this.search_data_index(type,id,key,conditions);
            if (index != -1) {
                if (type == 'is_auto') {
                    result = this.edit_order_data[index];
                } else {
                    result = this.edit_order_pack_data[index];
                }
            }
            return result;
        },
        save_data(type,data,key='pharmacy_medicine_id',conditions=null) {
            if (type == 'is_auto') {
                if (this.refresh_datetime == null) {
                    this.refresh_datetime = new Date();
                }
                let index = this.search_data_index(type,data[key],key,conditions);
                if (index != -1) {
                    this.edit_order_data[index] = data;
                } else {
                    this.edit_order_data.push(data);
                }
            } else if (type == 'is_auto_pack') {
                if (this.refresh_datetime == null) {
                    this.refresh_datetime = new Date();
                }
                let index = this.search_data_index(type,data[key],key,conditions);
                if (index != -1) {
                    this.edit_order_pack_data[index] = data;
                } else {
                    this.edit_order_pack_data.push(data);
                }
            }
        },
        delete_data(type,id,key='pharmacy_medicine_id',conditions=null) {
            if (type == 'is_wait') {
                for (let i=0;i<this.edit_wait_data.length;i++) {
                    if (this.edit_wait_data[i] == id) {
                        this.edit_wait_data.splice(i,1);
                        break;
                    }
                }
            } else if (type == 'is_auto') {
                let index = this.search_data_index(type,id,key,conditions);
                if (index != -1) {
                    this.edit_order_data.splice(index,1);
                }
            } else if (type == 'is_auto_pack') {
                //小分けに関してはconditionsが設定されていない場合は複数ある場合があるので全て削除する
                let index = this.search_data_index(type,id,key,conditions);
                if (index != -1) {
                    this.edit_order_pack_data.splice(index,1);
                }
                if (conditions == null) {
                    index = this.search_data_index(type,id,key,conditions);
                    while (index != -1) {
                        if (index != -1) {
                            this.edit_order_pack_data.splice(index,1);
                        }
                    }
                }
            }
        },
        reset_data(type = null) {
            if (type == null || type == 'is_auto') {
                this.edit_order_data.splice(0);
                this.edit_order_pack_data.splice(0);
                this.refresh_datetime = null;
            }
            if (type == null || type == 'is_wait') {
                this.edit_wait_data.splice(0);
            }
            if (type == null || type == 'is_pack_wait') {
                this.edit_pack_wait_data.splice(0);
            }
            if (type == null || type == 'is_pack_submit_wait') {
                this.edit_pack_submit_wait_data.splice(0);
            }
        },
        reset_setting() {
        },
        search_pack_submit_wait_by_id(pack_status,stock_id) {
            let result = null;
            for (let i=0;i<this.edit_pack_submit_wait_data.length;i++) {
                if ((this.edit_pack_submit_wait_data[i].pack_status == pack_status)) {
                    for (let j=0;j<this.edit_pack_submit_wait_data[i].pharmacy_pack_submit_waits.length;j++) {
                        if (this.edit_pack_submit_wait_data[i].pharmacy_pack_submit_waits[j].id == stock_id) {
                            result = {parent_index:i,child_index:j};
                            break;
                        }
                    }
                    if (result != null) {
                        break;
                    }
                }
            }
            return result;
        },
        create_pack_submit_wait(data) {
            let index = this.search_pack_submit_wait_by_id(data.pack_status,data.id);
            if (index == null) {
                this.edit_pack_submit_wait_data.push(data);
            }
        },
        update_pack_submit_wait(data) {
            let index = this.search_pack_submit_wait_by_id(data.pack_status,data.id);
            if (index != null) {
                this.edit_pack_submit_wait_data[index.parent_index] = {...data};
            }
        },
        delete_pack_submit_wait(parent_index,child_index=null) {
            if (child_index != null) {
                //ベースとなるレコードは削除出来ないようにする
                if (typeof this.edit_pack_submit_wait_data[parent_index].pharmacy_pack_submit_waits[child_index].id === 'string' && this.edit_pack_submit_wait_data[parent_index].pharmacy_pack_submit_waits[child_index].id.indexOf('-') != -1) {
                    this.edit_pack_submit_wait_data[parent_index].pharmacy_pack_submit_waits.splice(child_index,1);
                }
            } else {
                this.edit_pack_submit_wait_data.splice(parent_index,1);
            }
        },
    },
    persist: true,
})
